<ion-list>
  <ion-item lines='none' class="seats-container" *ngIf="program">
    <ion-label class="ion-text-center">
      <fa-icon [icon]="icons.pennant" slot="start" class="seats-icon section-title"></fa-icon>
      <ion-text color="secondary" *ngIf="program?.offered > 1">
        {{program?.offered}} seats offered!
      </ion-text>
      <ion-text color="danger" *ngIf="program?.offered === 1">
        {{program?.offered}} seat left!
      </ion-text>
      <ion-text color="danger" *ngIf="program?.offered === 0">
        No seats offered!
      </ion-text>
    </ion-label>
  </ion-item>
  <ion-button target="_blank" href="{{(toolService.content | async)?.basic?.url?.faq}}" fill="clear" color="light-teal-button" class="ion-text-wrap">
    <fa-icon slot="start" [icon]="icons.question"></fa-icon>
    <span class="form-text">Read our FAQ</span>
  </ion-button>
  <ion-button href='mailto:advisors@amopportunities.org' fill="clear" color="light-teal-button" class="ion-text-wrap">
    <fa-icon slot="start" [icon]="icons.phone"></fa-icon>
    <span class="form-text">Reach an advisor</span>
  </ion-button>
  <ion-button href='whatsapp://send?phone={{(toolService.content | async)?.basic?.whatsapp?.sam}}' fill=" clear" color="light-teal-button" class="ion-text-wrap whatsapp-button">
    <fa-icon slot="start" [icon]="icons.phone"></fa-icon>
    <span class="form-text">Reach us on Whatsapp</span>
  </ion-button>
  <ion-button *ngIf="hasApplication" (click)="cancelApplication(application?.id)" fill="clear" color="light-teal-button"
    class="ion-text-wrap">
    <fa-icon slot="start" [icon]="icons.exclamation"></fa-icon>
    <span class="form-text">Cancel application</span>
  </ion-button>
</ion-list>